export default __webpack_public_path__ + "static/media/pre_step3.f93d2429.png";